import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const ContainerCheckbox = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: ${theme.font.size14};
    
    > span {
        font-size: ${theme.font.size14};
        border: 1px solid red;
    }


    .MuiButtonBase-root {
        margin-right: 8px;
        
        & .MuiSvgIcon-root {
            width: 18px;
        }
    }

    .MuiFormControlLabel-root {
        min-width: 250px;
        width: ${({ columns }) => `${Math.floor(100 / columns)}%`};
        margin-left: 0px;
        padding-bottom: 16px;
        
        & span{
            color: ${(props) => props.theme.blackLink};
        }
    }

    .Mui-checked.Mui-disabled {
        color: ${(props) => props.theme.lightGrey};
    }

    @media(min-width: 1024px) {
        div.MuiFormGroup-root {
            flex-direction: row;
        }
    }
`;

export const FormControlText = styled.div`
    font: ${theme.font.body[6]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.blackLink};
    font: inherit;
`;
